/** Projects API calls (typed). */

import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
  type PaginatedResponse,
  type QueryParams,
} from "@/lib/api-client";
import type { ApiProject, ApiProjectComment } from "./projects.adapter";

export interface ProjectsListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  clientId?: string;
  archived?: boolean;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const projectsApi = {
  list: (params: ProjectsListParams = {}) =>
    apiGet<PaginatedResponse<ApiProject>>("/projects", params as QueryParams),
  get: (id: string) => apiGet<ApiProject>(`/projects/${id}`),
  create: (body: Record<string, unknown>) => apiPost<ApiProject>("/projects", body),
  update: (id: string, body: Record<string, unknown>) =>
    apiPatch<ApiProject>(`/projects/${id}`, body),
  setStatus: (id: string, status: string) =>
    apiPatch<ApiProject>(`/projects/${id}/status`, { status }),
  addComment: (id: string, body: string) =>
    apiPost<ApiProjectComment>(`/projects/${id}/comments`, { body }),
  archive: (id: string) => apiDelete<ApiProject>(`/projects/${id}`),
  restore: (id: string) => apiPost<ApiProject>(`/projects/${id}/restore`),
};
